import type { FC } from "react";

import type { Sailing } from "../common/graphql/fragments/gql/Sailing";
import type { BookingStatus } from "../gql/graphql";
import { PortDetails } from "./PortDetails";

interface PortDetailsForSailingProps {
  bookingStatus?: BookingStatus | null;
  sailing: Sailing;
}

export const PortDetailsForSailing: FC<PortDetailsForSailingProps> = ({
  sailing,
  bookingStatus,
}) => {
  return (
    <PortDetails
      departureLocation={
        sailing.route.departureLocation.longName ??
        sailing.route.departureLocation.name
      }
      arrivalLocation={
        sailing.route.arrivalLocation.longName ??
        sailing.route.arrivalLocation.name
      }
      departureDate={sailing.departureDate}
      departureTime={sailing.departureTime}
      arrivalDate={sailing.arrivalDate}
      arrivalTime={sailing.arrivalTime}
      bookingStatus={bookingStatus}
    />
  );
};
